export default {
  "en": {
    "button": {
      "actions": {
        "add": "Add",
        "cancel": "Cancel",
        "create": "Create",
        "delete": "Delete",
        "edit": "Edit",
        "hide": "Hide",
        "loading": "Loading",
        "move": "Move",
        "reset": "Reset",
        "save_changes": "Save changes",
        "save_message": "Save message",
        "saving": "Saving",
        "share": "Share",
        "uploadingDocuments": "Uploading documents",
        "yes": "Yes"
      }
    }
  }
}